"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.freezeAnyOfAttribute = void 0;
const index_js_1 = require("../../errors/index.js");
const isArray_js_1 = require("../../utils/validation/isArray.js");
const attributeOptions_js_1 = require("../constants/attributeOptions.js");
const hasDefinedDefault_js_1 = require("../shared/hasDefinedDefault.js");
const validate_js_1 = require("../shared/validate.js");
const interface_js_1 = require("./interface.js");
/**
 * Freezes a warm `anyOf` attribute
 *
 * @param elements Attribute elements
 * @param state Attribute options
 * @param path Path of the instance in the related schema (string)
 * @return void
 */
const freezeAnyOfAttribute = (state, elements, path) => {
    (0, validate_js_1.validateAttributeProperties)(state, path);
    if (!(0, isArray_js_1.isArray)(elements)) {
        throw new index_js_1.DynamoDBToolboxError('schema.anyOfAttribute.invalidElements', {
            message: `Invalid anyOf elements${path !== undefined ? ` at path '${path}'` : ''}: AnyOf elements must be an array.`,
            path
        });
    }
    if (elements.length === 0) {
        throw new index_js_1.DynamoDBToolboxError('schema.anyOfAttribute.missingElements', {
            message: `Invalid anyOf elements${path !== undefined ? ` at path '${path}'` : ''}: AnyOf attributes must have at least one element.`,
            path
        });
    }
    elements.forEach(element => {
        const { required, hidden, savedAs } = element[attributeOptions_js_1.$state];
        if (required !== 'atLeastOnce' && required !== 'always') {
            throw new index_js_1.DynamoDBToolboxError('schema.anyOfAttribute.optionalElements', {
                message: `Invalid anyOf elements${path !== undefined ? ` at path '${path}'` : ''}: AnyOf elements must be required.`,
                path
            });
        }
        if (hidden !== false) {
            throw new index_js_1.DynamoDBToolboxError('schema.anyOfAttribute.hiddenElements', {
                message: `Invalid anyOf elements${path !== undefined ? ` at path '${path}'` : ''}: AnyOf elements cannot be hidden.`,
                path
            });
        }
        if (savedAs !== undefined) {
            throw new index_js_1.DynamoDBToolboxError('schema.anyOfAttribute.savedAsElements', {
                message: `Invalid anyOf elements${path !== undefined ? ` at path '${path}'` : ''}: AnyOf elements cannot be renamed (have savedAs option).`,
                path
            });
        }
        if ((0, hasDefinedDefault_js_1.hasDefinedDefault)(element)) {
            throw new index_js_1.DynamoDBToolboxError('schema.anyOfAttribute.defaultedElements', {
                message: `Invalid anyOf elements${path !== undefined ? ` at path '${path}'` : ''}: AnyOf elements cannot have default or linked values.`,
                path
            });
        }
    });
    const frozenElements = elements.map(element => element.freeze(path));
    return new interface_js_1.AnyOfAttribute_({
        path,
        elements: frozenElements,
        ...state
    });
};
exports.freezeAnyOfAttribute = freezeAnyOfAttribute;
